import { RichText } from "@vinomofo/gatsby-types";
import { Blockquote } from "../components/blockquote";
import { richTextRenderer } from "../utils/rich-text-renderer";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_QuoteBlock";

const create = (data: {
  authorName?: string;
  authorTitle?: string;
  quoteText: {
    [key: string]: any;
  };
}): JSX.Element => {
  const { authorName, authorTitle, quoteText } = data;

  const quoteTextJson = { json: JSON.parse(quoteText.raw) };

  return (
    <Blockquote
      authorName={authorName}
      authorTitle={authorTitle}
      quoteText={richTextRenderer(quoteTextJson, {
        p: {
          fontFamily: "heading",
          fontWeight: 500,
          fontSize: [4, 5, 7],
          color: "text.heading",
        },
      })}
    />
  );
};

export default { test, create };
